<template>
	<div class="flex box start">
		<loader></loader>
		<div class="card nine-lg">
			<header class="card-header">
				<h3 class="card-title">Users monthly logs</h3>
			</header>
			<div class="card-body">
				<div v-if="auditLogs" class="table-lister table-responsive">
					<table>
						<thead>
							<tr>
								<th>
									<span class="th">User</span>
								</th>
								<th>
									<span class="th">Events</span>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(auditLog, index) in auditLogs">
								<td><strong>{{ auditLog.userName }}</strong></td>
								<td>
									<div class="article-title audit-list" v-for="(data, slug) in auditLog.logs">
										<div class="audit-title">{{ slug }}</div>
										<ul v-for="(action, date) in data" class="list">
											<li>
												<strong>#{{ action.id }}</strong>
												<span class="badge"
													  v-bind:class="{
												'badge-warning': action.event === 'updated',
												'badge-success': action.event === 'created',
												'badge-primary': action.event === 'published',
												'badge-danger': action.event === 'deleted' || action.event === 'archived',
											}">{{ action.event }}</span>
												{{ action.type }}
											</li>
											<li>
												 {{ action.title }} <span style="float: right">{{ date }}</span>
											</li>
										</ul>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div class="card three-lg">
			<header class="card-header">
				<h3 class="card-title">Select month</h3>
			</header>
			<div class="card-body">
				<div class="form-group">
					<select id="tested_by" v-model="selectedMonth">
						<option :value="month.number" v-for="month in months">{{ month.name }}</option>
					</select>
				</div>
				<div class="form-group">
					<button class="btn btn-md btn-success" @click="loadData()">Show data</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {eventBus} from "../../app";

export default {
	name: "AuditsLogsByMonthsList",
	props: {
		dataAuditLogs: {
			type: Object
		},
		dataMonths: {
			type: Array
		},
		dataSelectedMonth: {
			type: String
		}
	},
	data() {
		return {
			auditLogs: this.dataAuditLogs,
			months: this.dataMonths,
			selectedMonth: this.dataSelectedMonth
		}
	},
	methods: {
		loadData: function () {
			let vm = this;

			let data = {
				'selectedMonth': this.selectedMonth
			}

			eventBus.$emit('onLoaderStart');
			axios.post('/api/audit/logs/user_data_by_month', data)
					.then(function (response) {
						if (response.data) {
							vm.auditLogs = response.data;
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.success('Data loaded', 'Success');
						} // if
					})
					.catch(function (e) {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.error('Could not load the data.', 'Error');
					});
		}
	}
}
</script>
